import { makeRequest } from "./general";

const apiUrl = window.apiUrl;
export default class PublicServices {
  constructor() {
    this.baseUrl = apiUrl;
  }

  async getDepartamentosLocalidades() {
    const url = `${this.baseUrl}/api/PublicServices/DepartamentosLocalidades`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }

  async getProfesionesRamos() {
    const url = `${this.baseUrl}/api/PublicServices/ProfesionesRamos`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }

  async getAgenciasRedPagos() {
    const url = `${this.baseUrl}/api/PublicServices/AgenciasRedPagos`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }

  async getNacionalidades() {
    const url = `${this.baseUrl}/api/PublicServices/Nacionalidades`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }

  async getTiposDeProfesiones() {
    const url = `${this.baseUrl}/api/PublicServices/TiposDeProfesiones`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }

  async getTerminosYCondiciones() {
    const url = `${this.baseUrl}/api/PublicServices/TerminosYCondiciones`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }
}
